/**
 * Formats a date string for chart and table display with padded day (2-digit)
 */
export const formatDateForDisplay = (dateString: string): string => {
	const date = new Date(dateString);
	return date.toLocaleDateString('en-US', {
		month: 'short',
		day: '2-digit',
		year: 'numeric'
	});
};

/**
 * Formats date values for table display
 */
export const formatDateForTable = (value: string | number): string => {
	if (typeof value === 'number') {
		const dateString = new Date(value).toISOString();
		return formatDateForDisplay(dateString);
	}
	return typeof value === 'string' ? formatDateForDisplay(value) : value;
};

/**
 * Formats a date and time for tooltip display with padded day (2-digit)
 */
export const formatDateTimeForTooltip = (dateString: string): { date: string; time: string } => {
	const date = new Date(dateString);
	const datePart = date.toLocaleDateString('en-US', {
		month: 'short',
		day: '2-digit',
		year: 'numeric'
	});
	const timePart = date.toLocaleTimeString('en-US', {
		hour: 'numeric',
		minute: '2-digit',
		hour12: true
	});
	return {
		date: datePart,
		time: timePart
	};
};
